// VideoForHomePage

const switchToVideo = (state) => {
  return {
    ...state,
    video: true
  }
}

export default switchToVideo